"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetToPhoneAuth = void 0;
var _actionGenerator = require("../../types/redux/actionGenerator");
var _types = require("./types");
const resetToPhoneAuth = exports.resetToPhoneAuth = (0, _actionGenerator.actionGenerator)(_types.EStateActionTypes.ResetStateToPhoneAuth);